const journeys = {
  journeyOfferPage: {
    journeyWith: "Journey with {{-pracName}}",
    title: "The first step on your personal health Journey",
    description:
      "Comprehensive blood panels with a personalized interpretation and action plan to help you live healthier, longer.",
    biomarkers: "<strong>{{count}}</strong> biomarker",
    biomarkers_plural: "<strong>{{count}}</strong> biomarkers",
    personalizedPlan:
      "A personalized plan created by <strong>{{-pracName}}</strong> that evolves with you",
    lifetimeAccess: "<strong>Lifetime access</strong> to results tracked over time",
    hsaEligible: "HSA/FSA eligible",
    oneTimeFee: "One time fee no hidden costs",
    getStarted: "Get started",
    biomarkersPopover: {
      title: "Biomarkers included",
    },
    dontWait: "Don't wait. Starting your preventative Journey is simple",
    howItWorks: "How it works",
    labTesting: "Lab testing",
    labTestingDescription:
      "Order your lab panel focused on the areas that matter most. No waiting rooms. No prescription needed. Just real data, fast.",
    resultsExplainedStep: "Results, clearly explained",
    resultsExplainedDescriptionStep:
      "You’ll be able to view and track your results, see what’s in range, what’s not, and what it means for your health. An expert practitioner translates the data into plain language and clear insights. ",
    personalizedPlanStep: "Personalized Wellness Plan",
    personalizedPlanDescriptionStep:
      "You'll get a personalized wellness plan built around your results. This can include supplements, nutrition, and lifestyle changes. Designed by your practitioner to be realistic, actionable, and effective.",
    retestProgressStep: "Re-test and track progress",
    retestProgressDescriptionStep:
      "Health isn’t static, and neither is your plan. Re-testing gives you and your practitioner a clear picture of what’s working and what to adjust, so your progress stays on track.",
    footerTitle:
      "This is the first step toward understanding your health more deeply — and taking control, <italic>together with {{-pracName}}</italic>",
    poweredBy: "Powered by",
  },
  JourneysList: {
    title: "Journeys Assistant",
    manageJourneyPanels: "Manage Journey panels",
    copyWebsiteUrl: "Copy website URL",
    invitePatient: "Invite a patient to start a journey",
  },
  JourneysFloatingBar: {
    patientDetailsButtonText: "Next",
    interpretationDetailsButtonText: "Build Wellness Plan",
    patientDetailsTextPrimary: "Next: Review Lab Results and Interpretation",
    patientDetailsTextSecondary:
      "The lab interpretation will <strong>not</strong> be shared with the patient yet",
    interpretationDetailsTextPrimary: "Next: Review Wellness Plan",
    interpretationDetailsTextSecondary:
      "The lab interpretation will <strong>not</strong> be shared with the patient yet",
  },
  WomensHormones: {
    menopauseStatus: {
      pre: "Pre-menopause",
      peri: "Peri-menopause",
      post: "Post-menopause",
    },
    menstrualCyclePhase: {
      follicular: "Follicular Phase",
      luteal: "Luteal Phase",
    },
    WomensHormonesRangeUsed: "Reference range used (based on women's hormones survey)",
  },
};

export { journeys };
